document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const nav = document.getElementById('PrimaryNavigation');

  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menuButton.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      nav.classList.toggle('mobile-open', !open);
    });
  }

  document.querySelectorAll('.nav-dropdown-toggle').forEach(button => {
    button.addEventListener('click', () => {
      const submenu = button.nextElementSibling;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (submenu) submenu.hidden = open;
    });
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;
    event.preventDefault();

    const data = new FormData(form);
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Accept':'application/json'},
      body: data
    })
    .then(response => {
      if (!response.ok) throw new Error('Cart error');
      return response.json();
    })
    .then(() => fetch('/cart.js'))
    .then(response => response.json())
    .then(cart => {
      const toast = document.querySelector('[data-cart-toast]');
      if (toast) {
        toast.textContent = 'Added to cart.';
        toast.classList.add('show');
        window.setTimeout(() => toast.classList.remove('show'), 2200);
      }
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    })
    .catch(() => {
      window.alert('Could not add this item to cart. Please try again.');
    })
    .finally(() => { btn.disabled = false; });
  });
});